import { Injectable, inject } from '@angular/core';
import { HttpService } from '../http/http.service';
import { JobService } from '../job/job.service';
import { GameId } from 'src/app/model/game/game-id';
import { WaitingOpponentsData } from '../../api/player/schemas/waiting-opponents';
import { PlayerApi } from '../../api/player/player-api';
import { AnalyticsService } from '../analytics/analytics.service';

@Injectable({
  providedIn: 'root',
})
export class WaitingOpponentsService {
  private httpService = inject(HttpService);
  private jobService = inject(JobService);
  private analyticsService = inject(AnalyticsService);

  async fetchWaitingOpponents(
    gameId: GameId,
    tournamentId: string | undefined,
  ): Promise<WaitingOpponentsData | undefined> {
    const job = this.jobService
      .create<WaitingOpponentsData>(async () => {
        return await PlayerApi.request(this.httpService, this.analyticsService).waitingOpponents(
          gameId,
          tournamentId,
        );
      })
      .showNoInternetRetry();

    return await job.runNoThrow();
  }
}
